"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useSsoProfile = void 0;
const react_1 = require("react");
const useSsoProfile = (userInfoUrl, accessToken) => {
    const [user, setUser] = (0, react_1.useState)();
    const [error, setError] = (0, react_1.useState)();
    const [loading, setLoading] = (0, react_1.useState)(false);
    const getUser = (0, react_1.useCallback)(async () => {
        try {
            setLoading(true);
            const response = await fetch(userInfoUrl, {
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: 'Bearer ' + accessToken,
                },
            });
            if (!response.ok) {
                const error = new Error('Fail to get user profile');
                error['response'] = response;
                throw error;
            }
            const data = await response.json();
            setUser(data);
            setError(undefined);
        }
        catch (error) {
            setUser(undefined);
            setError(error);
        }
        finally {
            setLoading(false);
        }
    }, []);
    (0, react_1.useEffect)(() => {
        getUser();
    }, [getUser]);
    return {
        user,
        error,
        loading,
        getUser,
    };
};
exports.useSsoProfile = useSsoProfile;
//# sourceMappingURL=useSsoProfile.js.map